package org.abhranilnxt.portfolio.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import org.abhranilnxt.portfolio.components.BackToTopButton
import org.abhranilnxt.portfolio.components.OverflowMenu
import org.abhranilnxt.portfolio.sections.AboutSection
import org.abhranilnxt.portfolio.sections.ContactSection
import org.abhranilnxt.portfolio.sections.ExperienceSection
import org.abhranilnxt.portfolio.sections.FooterSection
import org.abhranilnxt.portfolio.sections.MainSection
import org.abhranilnxt.portfolio.sections.ProjectsSection
import org.abhranilnxt.portfolio.sections.SkillsSection

@Page
@Composable
fun HomePage() {
    var menuOpened by remember { mutableStateOf(false) }
    Box(
        modifier = Modifier.fillMaxSize()
    ) {
        Column(
            modifier = Modifier.fillMaxSize(),
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            MainSection(
                onMenuClicked = {
                    menuOpened = true
                }
            )
            AboutSection()
            ProjectsSection()
            SkillsSection()
            ExperienceSection()
            ContactSection()
            FooterSection()
        }
        BackToTopButton()
        if(menuOpened) {
            OverflowMenu(onMenuClosed = { menuOpened = false })
        }
    }
}
